export default __webpack_public_path__ + "static/media/alETH.edec4865.svg";